import ConstantsImages from "../../../constants/ConstantsImages";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import { DivColumn, DivRow } from "../../../styles/SharedStyles";
import WidgetDropdown from "../widget-dropdown/WidgetDropdown";
import WidgetIcon from "../../icons/widget-icon/WidgetIcon";
import "./WidgetFilterDropdowns.css";

const WidgetFilterDropdowns = ({
  uniqueDistricts,
  uniqueMunicipalities,
  uniqueTerminals,
  selectedDistrict,
  selectedMunicipality,
  selectedTerminal,
  handleSelectDropdownDistrict,
  handleSelectDropdownMunicipality,
  handleSelectDropdownTerminal,
  handleSearchFrameClick,
  editModeProp = false,
  heightDropdownProp = "6rem",
  gapDropdownProp = "1.1rem",
  sizeIconProp = "6rem",
}) => {
  return (
    <DivColumn className="wfd-frame-3" style={{ gap: gapDropdownProp }}>
      <WidgetDropdown
        options={uniqueDistricts}
        labelKey="districtMOT"
        title={ConstantsTexts.CODE_63}
        onSelect={handleSelectDropdownDistrict}
        selectedOptionProp={selectedDistrict}
        heightProp={heightDropdownProp}
        enableSearch={true}
        enableClear={true}
      />
      <WidgetDropdown
        options={uniqueMunicipalities}
        labelKey="municipalityName"
        title={ConstantsTexts.CODE_64}
        onSelect={handleSelectDropdownMunicipality}
        selectedOptionProp={selectedMunicipality}
        heightProp={heightDropdownProp}
        enableSearch={true}
        enableClear={true}
      />
      <DivRow className="wfd-frame-4">
        <WidgetDropdown
          options={uniqueTerminals}
          labelKey="terminalName"
          title={ConstantsTexts.CODE_65}
          onSelect={handleSelectDropdownTerminal}
          selectedOptionProp={selectedTerminal}
          heightProp={heightDropdownProp}
          enableSearch={true}
          enableClear={true}
        />
        <WidgetIcon
          iconProp={ConstantsImages.SEARCH_IMAGE}
          heightProp={sizeIconProp}
          widthProp={sizeIconProp}
          widthIconProp="1.6rem"
          heightIconProp="1.6rem"
          backgroundColorProp={editModeProp ? "#C9CADE" : "#5051a1"}
          cursorProp={editModeProp ? "default" : "pointer"}
          handleOnClickProp={handleSearchFrameClick}
        />
      </DivRow>
    </DivColumn>
  );
};

export default WidgetFilterDropdowns;
